// Simple localStorage-backed shopping cart for Raw Company Clothing.
// Keeps it dependency-free (no redux/zustand). Components subscribe via the
// tiny event emitter below so the cart count + drawer update instantly.

const KEY = "rc_cart_v1";
const listeners = new Set();

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
};

const write = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  listeners.forEach((cb) => {
    try { cb(items); } catch { /* ignore listener errors */ }
  });
};

export const getCart = () => read();

export const subscribeCart = (cb) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};

// Cross-tab sync: when another tab changes the cart, notify local listeners.
if (typeof window !== "undefined") {
  window.addEventListener("storage", (e) => {
    if (e.key === KEY) listeners.forEach((cb) => { try { cb(read()); } catch { /* ignore */ } });
  });
}

export const addToCart = (product, size, quantity = 1) => {
  const items = read();
  const key = `${product.id}::${size}`;
  const found = items.find((i) => i.key === key);
  if (found) {
    found.quantity = Math.min(found.quantity + quantity, 99);
  } else {
    items.push({
      key,
      product_id: product.id,
      name: product.name,
      price: product.price,
      image_base64: product.image_base64,
      size,
      quantity,
    });
  }
  write(items);
};

export const removeFromCart = (key) => {
  write(read().filter((i) => i.key !== key));
};

export const updateCartQuantity = (key, quantity) => {
  const q = Math.max(1, Math.min(99, parseInt(quantity) || 1));
  const items = read().map((i) => (i.key === key ? { ...i, quantity: q } : i));
  write(items);
};

export const clearCart = () => write([]);

export const cartCount = () => read().reduce((n, i) => n + (i.quantity || 0), 0);

export const cartSubtotal = () =>
  read().reduce((s, i) => s + Number(i.price || 0) * (i.quantity || 0), 0);
